import { Component, OnInit, OnDestroy, ViewChild, HostListener, Input } from '@angular/core';
import * as Chart from 'chart.js';
import { HistoryCreditStatusModel } from '../../../models/consumer/history-credit-status.model';
import { ConsumerService } from '../../../services/consumer.service';
import { ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { HistoryConsumptionModel } from '../../../models/consumer/history-consumption.model';
import { pipe } from 'rxjs';
import { HistoryTarrifModel } from '../../../models/consumer/history-tarrif.model';

@Component({
  selector: 'tarrif-chart',
  template: '<canvas id="basechart" #basechart></canvas>',
  host: { 'class': 'block-detail' }
})
export class TarrifChartComponent implements OnInit, OnDestroy {

  @ViewChild('basechart', { static: true }) basechart: any;
  historyTarrif: HistoryTarrifModel[] = [];
  chart: any;
  subscriptions: any[] = [];
  debounceTimeout = 2000;
  debounceId: any;
  consumerId: string;
  heatTarrifChartData: any[] = [];
  StandingChargeChartData: any[] = [];
  heatGradientStroke: any;
  hotWaterGradientStroke: any;
  pipe: DatePipe = new DatePipe('en_GB');
    clientId: number;

  constructor(private consumerService: ConsumerService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.clientId = this.route.parent.snapshot.params['clientId'];
    this.subscriptions.push(this.route
      .params
      .subscribe(params => {
        this.consumerId = params['consumerId'];
      }));


    this.consumerService.getHistoryTarrif(this.clientId, this.consumerId).then((historyTarrifRes) => {
      this.historyTarrif = historyTarrifRes;

      this.heatTarrifChartData = this.historyTarrif
        .filter(x => x.chargetype == "Heat")
        .map(item => {
          return {
            x: item.date.toString(),
            y: item.amount
          }
        });

      this.StandingChargeChartData = this.historyTarrif
        .filter(x => x.chargetype == "Standing Charge")
        .map(item => {
          return {
            x: item.date.toString(),
            y: item.amount
          }
        });
    });

  }

  ngOnDestroy() {
    if (this.debounceId) {
      clearTimeout(this.debounceId);
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.createChart();
  }

  private getChartConfig(): any {
    let config = {
      type: 'bar',
      options: {
        maintainAspectRatio: true,
        steppedLine: true,
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            stacked: true,
            scaleLabel: {
              display: true,
              labelString: 'Date',
              fontSize: 15,
              fontStyle: "bold",
            },
            type: 'time',
            displayFormats: {
              'month': 'MM',
            },
            gridLines: {
              display: false
            },
            time: {
              unit: 'month',
              unitStepSize: 1,
              displayFormats: {
                'month': 'MMM'
              }
            }
          }],
          yAxes: [
            {
              stacked: true,
              scaleLabel: {
                display: true,
                labelString: 'Tarrif Amount',
                fontSize: 15,
                fontStyle: "bold",
              },
              position: 'left',
              gridLines: {
                display: true
              },
              ticks: {
                callback: (label: number, index: number, labels: any) => {
                  // comma separated thousands regex
                  return label.toString();
                }
              }
            },
          ]

        }
      }
    }

    return config;
  }

  createChart() {
    if (this.chart != null) this.chart.destroy();
    if (!this.basechart) return;

    let datasets = [] as any;

    datasets.push({
      label: 'heat consumption',
      lineTension: 0.1,
      data: this.heatTarrifChartData,
      spanGaps: true,
      backgroundColor: '#ff0000',
      pointRadius: 3,
      borderWidth: 2,
      pointHoverRadius: 5,
      pointHitRadius: 10,
      borderColor: '#ff0000',
      pointBorderColor: '#ff0000',
      pointBackgroundColor: '#ff0000',
      pointHoverBackgroundColor: '#ff0000',
      pointHoverBorderColor: '#ff0000',
    });

    datasets.push({
      label: 'heat consumption',
      lineTension: 0.1,
      data: this.StandingChargeChartData,
      spanGaps: true,
      backgroundColor: '#00ff00',
      pointRadius: 0,
      borderWidth: 2,
      pointHoverRadius: 5,
      pointHitRadius: 10,
      borderColor: '#00ff00',
      pointBorderColor: '#00ff00',
      pointBackgroundColor: '#00ff00',
      pointHoverBackgroundColor: '#00ff00',
      pointHoverBorderColor: '#00ff00',
    });

    let config = this.getChartConfig();
    let chartConfiguration: Chart.ChartConfiguration = {
      type: config.type,
      options: config.options,
      data: { datasets: datasets }
    };

    if (this.debounceId) {
      window.clearTimeout(this.debounceId);
    };

    this.debounceId = window.setTimeout(() => {
      if (this.chart != null) this.chart.destroy();
      let ctx = this.basechart.nativeElement;
      this.chart = new Chart(ctx, chartConfiguration);
    }, this.debounceTimeout);
  }

}
